import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../../../services/api.service';
import {LoginService} from '../../../services/login.service';
import {NotificationsService} from 'angular2-notifications';
import {BarChartComponent} from '../zoomView/bar-chart/bar-chart.component';
import {ModalService} from '../../../services/modalService/modal.service';
import {UtilsService} from '../../../services/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../../../helper/backend-translate.service';

@Component({
  selector: 'app-user-sessions',
  templateUrl: './user-sessions.component.html',
  styleUrls: ['./user-sessions.component.css', '../myreports.component.css']
})
export class UserSessionsComponent implements OnInit {

  ruid:string;
  public barChartData = [];
  chartData:any;
  public options = {
    height: 400,
    titlePosition: 'out',
    chartArea: {height: '100%', width: '60%', left: 150},
    vAxis: {title: this.translate.instant('reports.user.users'), textStyle: {fontSize: 13}},
    colors: ['#4caf50', '#ffc107'],
    hAxes: {
      0: {title: this.translate.instant('reports.noSession')},
      1: {title: this.translate.instant('reports.totalUsage'), formatter: 'minsToHours'}
    },
    series: {
      0: {targetAxisIndex: 0},
      1: {targetAxisIndex: 1},
      2: {targetAxisIndex: 1}
    },
    showAnnotations: true
  };
  isloggedIn = false;
  isLicense: string;

  chartError = false;

  constructor(private apiService: ApiService,
              private loginService: LoginService,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private modalService: ModalService,
              private utilService: UtilsService,
              private translate: TranslateService,
              private backendTranslate: BackendTranslateService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        if (this.ruid === 'demo') {
          this.reportsData();
        } else {
          this.loginService.isLoggedIn()
            .subscribe((currentUser) => {
              this.isloggedIn = currentUser.isLoggedIn;
              if (this.isloggedIn) {
                this.apiService.getSummary(this.ruid)
                  .subscribe((res) => {
                    this.isLicense = res.isLicense;
                    if (!res.isLicense) {
                      this.reportsData();
                    }
                  }, (error) => {
                      this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid')));
                  });
              }
            });
        }
      }
    });
  }

  reportsData() {
    this.apiService.getChartData(this.ruid, 'SESSIONS_BY_USER')
      .subscribe((res) => {
        res.data[0] = this.backendTranslate.translateCollection(res.data[0]);
        this.chartData = res;
        this.barChartData = res.data;
        this.utilService.updateChartAreaFromData(this.barChartData, this.options);
      }, (error) => {
          this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.sessionFail')));
      });
  }

  zoomView() {
    if (this.barChartData.length === 0) {
        return;
    }
    this.modalService.open(BarChartComponent, {
      title: this.translate.instant('reports.userSessions.top'),
      data: {
        chartData: this.chartData,
        isLicense: this.isLicense,
        options: this.options
      }
    }).subscribe();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/user-sessions/user-sessions.component.ts